import { render } from "./Content.vue?vue&type=template&id=3fe1e8c6"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import exportComponent from "D:\\p2h_proj\\californiamilkprocessorboard\\markup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__